import React from 'react';
import { Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { set, cloneDeep, get } from 'lodash';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { customStyles, roundingOff, allowOnlyNumber, currency_symbols } from '../../../../../Components/helper';
import { colourPath } from '../../fieldPath';
import { usePurchaseOrderState } from '../../PurchaseOrderContext/index';
import useMultiTypePackedUnits from '../../Hooks/useMultiTypePackedUnits';
import useGrandTotal from '../../Hooks/useGrandTotal';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

export const MultSizePackedUnits = ({ data, parentIndex }) => {
  const { t } = useTranslation('common');
  const {
    purchaseOrderData: { sizesData, legLengths },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);
  const { calculateGrandTotal } = useGrandTotal();
  const {
    purchaseOrderState: { selectedCurrency },
    setPurchaseOrderState,
    purchaseOrderState,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    poAddEditAccess,
    poDeleteAccess,
    lengthEnabled,
  } = usePurchaseOrderState();
  const { calculateMultiPackedUnits } = useMultiTypePackedUnits();

  const onChange = async (value, keyValue, i) => {
    const copyState = purchaseOrderState;
    set(copyState, keyValue, value);
    const multiSizePackedUnitsPath = colourPath(parentIndex, i).MULTI_SIZE_PACKED_UNITS.COMMON_PATH;
    const multiSizepackedUnits = get(copyState, multiSizePackedUnitsPath);
    const obj = cloneDeep(await calculateMultiPackedUnits(multiSizepackedUnits));
    set(copyState, multiSizePackedUnitsPath, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(copyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addRow = async (element, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.multipleTotalPackedRows.push(element);
    const obj = cloneDeep(await calculateMultiPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteRow = async (i, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.multipleTotalPackedRows.splice(i, 1);
    const obj = cloneDeep(await calculateMultiPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addNewCard = async (e, element) => {
    e.preventDefault();
    const copyState = cloneDeep(data);
    const tempEle = element;
    tempEle.shipmentDate = null;
    tempEle.handOverDate = null;
    copyState.push(tempEle);
    const obj = cloneDeep(await calculateMultiPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteExistingCard = async (e, i) => {
    e.preventDefault();
    const copyState = cloneDeep(data);
    copyState.splice(i, 1);
    const obj = cloneDeep(await calculateMultiPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const changeHandOverDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.handOverDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const changeShipmentDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.shipmentDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multipleTotalPacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const hasDate = (element) => {
    return element ? new Date(element) : null;
  };

  return data?.map((ele, i) => {
    return (
      <Card key={i} className="card-margin-bottom rounded-0">
        <Card.Header className="bgcolor-dark rounded-0">
          <div className="d-flex  align-items-center p-2">
            <strong>{t('FILTER.MULTI_SIZE_PACKED_UNIT')}</strong>
            <div className="date px-3 ml-auto">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.HANDOVER_DATE_MULTISIZER')}
                  popperPlace="top-end"
                  placeholder={t('FILTER.HANDOVER_DATE')}
                  keyProp={`handOverDate_${parentIndex}_${i}_MultiSizepack`}
                  disable
                  onChange={(e) => changeHandOverDate(e, i)}
                  valueProp={hasDate(data[i]?.handOverDate)}
                />
              </div>
            </div>
            <div className="date justify-content-end px-1">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.SIMPLE_MULTISIZE_DATE')}
                  popperPlace="top-end"
                  keyProp={`shipmentDate_${parentIndex}_${i}_MultiSizepack`}
                  placeholder={t('FILTER.SHIPMENT_DATE')}
                  disable
                  onChange={(e) => changeShipmentDate(e, i)}
                  valueProp={hasDate(data[i]?.shipmentDate)}
                />
              </div>
            </div>
          </div>
        </Card.Header>
        {!fromPreview && !isPublicPoPage && (
          <div className="d-flex pt-2 justify-content-end">
            {data?.length === i + 1 && poAddEditAccess && (
              <button className="btn btn-outline" type="button" onClick={(e) => addNewCard(e, ele)} disabled>
                <i className="icon-add" />
              </button>
            )}
            {data?.length !== 1 && poDeleteAccess && (
              <button className="btn btn-outline px-1" type="button" onClick={(e) => deleteExistingCard(e, i)} disabled>
                <i className="icon-delete" />
              </button>
            )}
          </div>
        )}
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-3">
              <thead>
                <tr>
                  <th>{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                  {lengthEnabled && <th>{t('PROGRESS_INDICATOR.LENGTH')}</th>}
                  <th>{t('FILTER.PACK_RATIO')}</th>
                  <th>{t('FILTER.TOTAL_PACKS')}</th>
                  <th>{t('FILTER.TOTAL_UNITS')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_RATIO')}</th>
                  <th>{t('FILTER.DISCOUNT_PER_UNIT')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_DISCOUNTS')}</th>
                  {!fromPreview && !isPublicPoPage && <th>{t('COSTING_TO_DO_LIST.ACTION')}</th>}
                </tr>
              </thead>
              <tbody>
                {ele?.multipleTotalPackedRows?.map((element, index) => {
                  return (
                    ((fromPreview && isPublicPoPage && element?.size) || !fromPreview || !isPublicPoPage) && (
                      <tr key={index}>
                        <td>
                          <div className="custom-react-select">
                            <Select
                              name="Size"
                              options={sizesData}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              value={(element?.size || typeof element?.size === 'number' ? { name: element?.size } : null) || ''}
                              isDisabled
                              styles={customStyles}
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              onChange={(event) => onChange(event?.name, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.SIZE_PATH, i)}
                              placeholder={t('FILTER.SELECT_SIZE')}
                            />
                          </div>
                        </td>
                        {lengthEnabled && (
                          <td>
                            <Select
                              name="Length"
                              options={legLengths}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.length ? element?.length : null) || ''}
                              styles={customStyles}
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              isDisabled
                              onChange={(event) => onChange({ name: event?.name }, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.LENGTH_PATH, i)}
                              placeholder={t('FILTER.SELECT_LENGTH')}
                            />
                          </td>
                        )}
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Pack Ratio"
                            placeholder={t('FILTER.PACK_RATIO')}
                            className="form-control text-bordered"
                            value={element?.packRatio || ''}
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.PACK_RATIO, i)}
                          />
                        </td>
                        {ele?.multipleTotalPackedRows?.length === 1 ? (
                          <td rowSpan={index === 0 && ele?.multipleTotalPackedRows?.length}>
                            <input
                              type="text"
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={(e) => allowOnlyNumber(e)}
                              name="Total Packs"
                              placeholder={t('FILTER.TOTAL_PACKS')}
                              className="form-control text-bordered"
                              value={ele?.totalPacks || ''}
                              disabled
                              onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.PACK_QUANTITY, i)}
                            />
                          </td>
                        ) : (
                          index === 0 && (
                            <td rowSpan={ele?.multipleTotalPackedRows?.length}>
                              <input
                                type="text"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => allowOnlyNumber(e)}
                                name="Total Packs"
                                placeholder={t('TAKING_DATES.PACKS')}
                                className="form-control text-bordered"
                                value={ele?.totalPacks || ''}
                                disabled
                                onChange={(event) => onChange(event.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.PACK_QUANTITY, i)}
                              />
                            </td>
                          )
                        )}
                        {ele?.multipleTotalPackedRows?.length === 1 ? (
                          <td>
                            <strong>{ele?.totalUnits ? new Intl.NumberFormat().format(ele?.totalUnits) : null}</strong>
                          </td>
                        ) : (
                          index === 0 && (
                            <td rowSpan={ele?.multipleTotalPackedRows?.length}>
                              <strong>{ele?.totalUnits ? new Intl.NumberFormat().format(ele?.totalUnits) : null}</strong>
                            </td>
                          )
                        )}
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (Before Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_RATIO')}
                            className="form-control text-bordered"
                            value={element?.beforeDiscPrice || ''}
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.BEFORE_DESCOUNT, i)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Discount"
                            placeholder={t('PROGRESS_INDICATOR.DISCOUNT')}
                            className="form-control text-bordered"
                            value={element?.discount || ''}
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.DISCOUNT, i)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (After Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_DISCOUNTS')}
                            className="form-control text-bordered"
                            value={(element?.afterDiscPrice ? roundingOff(element?.afterDiscPrice, 2) : null) || ''}
                            readOnly
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_SIZE_PACKED_UNITS?.AFTER_DISCOUNT, i)}
                          />
                        </td>
                        {!fromPreview && !isPublicPoPage && (
                          <td>
                            <div className="d-flex">
                              {poAddEditAccess && (
                                <button
                                  title={t('COMMON_LABEL.ADD')}
                                  aria-label={t('COMMON_LABEL.ADD')}
                                  type="button"
                                  disabled
                                  className="btn btn-outline"
                                  onClick={() => addRow(element, i)}
                                >
                                  <i className="icon-add" />
                                </button>
                              )}
                              {ele?.multipleTotalPackedRows?.length !== 1 && poDeleteAccess && (
                                <button
                                  title={t('COMMON_LABEL.DELETE')}
                                  aria-label={t('COMMON_LABEL.DELETE')}
                                  className="btn btn-outline px-1"
                                  type="button"
                                  disabled
                                  onClick={() => deleteRow(index, i)}
                                >
                                  <i className="icon-delete" />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                <tr key={i}>
                  <td colSpan={9}>
                    <strong className="align-item-center justify-content-center d-flex">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalSize) || !fromPreview || !isPublicPoPage) && (
                        <strong>{ele?.totalSize ? new Intl.NumberFormat().format(roundingOff(ele?.totalSize, 2)) : null}</strong>
                      )}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalLength) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalLength ? new Intl.NumberFormat().format(roundingOff(ele?.totalLength, 2)) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalPackRatio) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalPackRatio ? new Intl.NumberFormat().format(roundingOff(ele?.totalPackRatio, 2)) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalPacks) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalPacks ? new Intl.NumberFormat().format(roundingOff(ele?.totalPacks, 2)) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalUnits) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalUnits ? new Intl.NumberFormat().format(roundingOff(ele?.totalUnits, 2)) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {ele?.totalPriceBeforeDisc ? (
                        <>
                          <span className="px-1">
                            {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                          </span>
                          {((fromPreview && isPublicPoPage && ele?.totalPriceBeforeDisc) || !fromPreview || !isPublicPoPage) &&
                            new Intl.NumberFormat().format(roundingOff(ele?.totalPriceBeforeDisc, 2))}
                        </>
                      ) : null}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalDiscountPerUnit) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalDiscountPerUnit ? new Intl.NumberFormat().format(roundingOff(ele?.totalDiscountPerUnit, 2)) : null)}
                    </strong>
                  </td>
                  <td colSpan={2}>
                    <strong>
                      {ele?.totalPriceAfterDisc ? (
                        <>
                          <span className="px-1">
                            {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                          </span>
                          {((fromPreview && isPublicPoPage && ele?.totalPriceAfterDisc) || !fromPreview || !isPublicPoPage) &&
                            new Intl.NumberFormat().format(roundingOff(ele?.totalPriceAfterDisc, 2))}
                        </>
                      ) : null}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );
  });
};

export default MultSizePackedUnits;
